<template>
  <div>
    <pop-modal :visible="isXgfpVisible" :isDrag="true" title="读入新购发票" width="60%" :height="70" @cancel="handelCancel">
      <h5>从金税设备读入新购发票完毕，发票卷信息如下：</h5>
      <m-table
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="fpData"
      ></m-table>
      <div class="foot-btn">
        <a-button type="primary" ghost @click="submitFrom()"> 确定 </a-button>
      </div>
    </pop-modal>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
export default {
  data() {
    return {
      isXgfpVisible: false,
      pagination: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '发票种类',
          dataIndex: 'taxClass',
          width: 100,
          customRender: (v) => (v === '0' ? '专用发票' : v === '1' ? '普通发票' : '电子普通发票'),
        },
        {
          title: '开票限额',
          dataIndex: 'invoiceQuota',
          width: 100,
        },
        {
          title: '类别代码',
          dataIndex: 'taxBillCode',
          width: 100,
        },
        {
          title: '类别名称',
          dataIndex: 'address',
          width: 100,
        },
        {
          title: '起始号码',
          dataIndex: 'taxBillSurNoStart',
          width: 100,
        },
        {
          title: '发票张数',
          dataIndex: 'taxBillsurNum',
          width: 100,
        },
        {
          title: '领购日期',
          dataIndex: 'taxBillBuyDate',
          width: 100,
        },
      ],
      fpData: [],
      domainName: '',
      searchFp: false,
      isShow: false,
      drID: '',
    }
  },
  methods: {
    show(writeToIC) {
      this.getIcManageList(writeToIC)
    },
    /**
     * 发票读入/库存查询退回接口   writeToIC为0表示读入发票
     */
    async getIcManageList(writeToIC) {
      const params = parseParam({
        isWriteToIC: writeToIC,
      })
      const res = await this.$http.post(`${Urls.getIcManageList}&${params}`)
      if (res) {
        this.fpData = res.data
        this.domainName = res.domainName
        if (writeToIC === 0) {
          this.isXgfpVisible = true
          // this.msg.tipMsgVisible = false;
        } else if (writeToIC === 1) {
          this.searchFp = true
          this.show = false
        }
      }
    },
    handelCancel() {
      this.isXgfpVisible = false
    },
    async submitFrom() {
      if (this.drID == null || this.drID === '') {
        this.$error({
          title: '警告',
          content: '请选择发票进行导入',
        })
        return
      }
      const ID = this.drID
      const params = parseParam({
        id: ID,
      })
      const res = await this.$http.post(`${Urls.importIcManage}&${params}`)
      if (res) {
        // this.$message.success('发票已入库！')
        this.handelCancel()
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.drID = this.selectedRowKeys[0].id
    },
  },
}
</script>

<style lang="less" scoped>
.foot-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
}
</style>
